import * as Blockly from 'blockly/core'

/**
 * Blockly のフィールドエディタ（数値入力の WidgetDiv / ドロップダウン）を
 * 閉じて、編集中の値を確定させる。フィールド編集中にプレビューをクリック
 * したり実行ボタンを押しても、エディタの input が開いたままだと値が確定
 * されず、プレビューの実行に反映されない。プレビュー操作の起点で明示的に
 * 閉じることで、編集途中の値を確定してから実行・操作できるようにする。
 *
 * @returns エディタが実際に開いていた（＝確定が発生した）かどうか。
 *   確定が発生すると Blockly の change イベント → デバウンス経由で
 *   workspaces が差し替わるため、呼び出し側は実行の再開始を予約する。
 */
export const commitBlocklyFieldEdits = (): boolean => {
  const wasEditing =
    Blockly.WidgetDiv.isVisible() || Blockly.DropDownDiv.isVisible()
  Blockly.WidgetDiv.hide()
  Blockly.DropDownDiv.hideWithoutAnimation()
  return wasEditing
}

/**
 * フィールド確定起因の workspaces 差し替えを「再実行」として扱う猶予（ms）。
 * 確定 → Blockly の change イベント（非同期） → エディタ側のデバウンス
 * （約 300ms） → workspaces 差し替え、までの伝播を余裕を持って覆う長さ。
 */
export const FIELD_COMMIT_RESTART_GRACE_MS = 1000
